import { FEATURES } from "./data";
import { Reveal, Overline } from "./primitives";
import { ArrowUpRight } from "lucide-react";

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <Overline>Capabilities</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.06] tracking-tight text-slate-900 sm:text-5xl">
                Powerful Engineering Capabilities
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-[15px] leading-relaxed text-slate-500">
              Every tool works together to turn a route on a map into a
              documented, engineering-based pipeline design.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => {
            const isWide = i === 6; // report card spans full width on lg
            return (
              <Reveal
                key={f.title}
                delay={(i % 3) * 0.07}
                className={isWide ? "lg:col-span-3" : ""}
              >
                <div
                  className={`group relative flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lg ${
                    isWide
                      ? "bg-[#0e3f70] text-white"
                      : "bg-white hover:border-[#1a6fc4]/25"
                  }`}
                >
                  {isWide && (
                    <div className="absolute inset-0 pm-grid-blue opacity-40" />
                  )}
                  <div className="relative flex items-start justify-between">
                    <div
                      className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-300 ${
                        isWide
                          ? "bg-white/10 text-[#a6d47a]"
                          : "bg-[#1a6fc4]/8 text-[#1a6fc4] group-hover:bg-[#1a6fc4] group-hover:text-white"
                      }`}
                    >
                      <f.icon className="h-6 w-6" strokeWidth={1.7} />
                    </div>
                    <ArrowUpRight
                      className={`h-5 w-5 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${
                        isWide ? "text-white/60" : "text-slate-300"
                      }`}
                    />
                  </div>
                  <h3
                    className={`relative mt-6 font-heading text-xl font-bold tracking-tight ${
                      isWide ? "text-white" : "text-slate-900"
                    }`}
                  >
                    {f.title}
                  </h3>
                  <p
                    className={`relative mt-3 text-[15px] leading-relaxed ${
                      isWide ? "text-white/75" : "text-slate-600"
                    }`}
                  >
                    {f.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
